module.exports = __webpack_public_path__ + "img/926b386.jpeg";